import React from "react"
import { Tabs, Tab } from "material-ui/Tabs"
import AccountUsersTab from "./AccountUsersTab"
import AccountRolesTab from "./AccountRolesTab"
import strings from "../../../localization/strings"
import autobind from "class-autobind"
import AuthenticationStore from "../../../stores/AuthenticationStore"

const accountActions = require("../../../actions/AccountActions")

export default class AccountUsers extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
        autobind(this)
    }

    componentDidMount() {
        accountActions.getAccountUsers(AuthenticationStore.getCookieAccountId())
    }

    render() {
        return (
            <div className="AccountUsers">
                <Tabs>
                    <Tab data-intercom-target={"menu-AccountUsers-UsersTab"} label={strings.Users.toUpperCase()}>
                        <AccountUsersTab />
                    </Tab>
                    <Tab data-intercom-target={"menu-AccountUsers-RolesTab"} label={strings.Roles.toUpperCase()}>
                        <AccountRolesTab />
                    </Tab>
                </Tabs>
            </div>
        )
    }
}
